// extracted by mini-css-extract-plugin
export var fullGrid = "_2w-3";
export var pdpPreviewContainer = "_2w-1";
export var previewContainer = "_2w-0";
export var togglePreviewContainer = "_2w-2";